import { translate } from '#packages/i18n';
import constants from '#packages/constants';

import type { SerializedCompStructure } from '@wix/document-services-types';

const BLANK_SECTION_LABEL = 'section_name_blank';

export const getBlankSectionStructure = ({
  height,
  y,
  name,
  design,
}: {
  height: number;
  y: number;
  name?: string;
  design?: Object;
}): SerializedCompStructure => {
  return {
    anchor: {
      name: name || translate(BLANK_SECTION_LABEL),
      type: 'AnchorInfo',
    } as SerializedCompStructure['anchor'],
    design: {
      type: 'MediaContainerDesignData',
      background: {
        mediaRef: null,
        fittingType: 'fill',
        alignType: 'center',
        colorOverlay: '',
        colorOverlayOpacity: 1,
        color: 'color_11',
        colorOpacity: 0,
        type: 'BackgroundMedia',
        imageOverlay: '',
        scrollType: 'none',
      },
      ...design,
    },
    components: [],
    componentType: constants.COMP_TYPES.SECTION,
    layout: {
      x: 0,
      y,
      scale: 1,
      height,
      rotationInDegrees: 0,
      width: 980,
    },
    type: 'Container',
    props: {
      type: 'ClassicSectionProperties',
    },
  };
};
